import type { DashboardModuleId } from './types';
import {
  BarChart3,
  CalendarClock,
  Gamepad2,
  MessageCircle,
  Music,
  Sparkles,
  type LucideIcon,
} from 'lucide-react';

export interface ModuleConfig {
  id: DashboardModuleId;
  label: string;
  description: string;
  icon: LucideIcon;
}

export const DASHBOARD_MODULES: ModuleConfig[] = [
  {
    id: 'general',
    label: 'Uso Geral',
    description: 'Visão consolidada de alunos, professores e sessões',
    icon: BarChart3,
  },
  {
    id: 'communication',
    label: 'Comunicação',
    description: 'Categorias, subcategorias e evolução semanal',
    icon: MessageCircle,
  },
  {
    id: 'routines',
    label: 'Rotinas',
    description: 'Rotinas visuais, horários e criação por professor',
    icon: CalendarClock,
  },
  {
    id: 'games',
    label: 'Jogos',
    description: 'Taxa de acerto, evolução e comparação entre escolas',
    icon: Gamepad2,
  },
  {
    id: 'ai',
    label: 'Desenho com IA',
    description: 'Reconhecimento de desenhos e evolução do usuário',
    icon: Sparkles,
  },
  {
    id: 'music',
    label: 'Música',
    description: 'Gêneros preferidos e tempo de reprodução',
    icon: Music,
  },
];

export function getModuleConfig(id: DashboardModuleId) {
  return DASHBOARD_MODULES.find((m) => m.id === id)!;
}
